<div class="h-screen w-screen sticky top-1/2 flex justify-end overflow-x-hidden">
    <div class="flex justify-end">
        <div class=" [writing-mode:vertical-lr] text-lg self-center absolute top-1/2 transform -translate-y-1/2 pointer-events-auto">
            <button (click)="toggleInfo('billOfQuantities')"
                    data-cy="info-area-bill-of-quantities"
                    class="toggle-info-area-button bg-secondary-300 rounded-t-[2rem] rounded-bl-[2rem] p-4 text-white font-bold">
                {{ 'MAIN_LAYOUT.BILL_OF_QUANTITIES' | translate }}
            </button>

            <button (click)="toggleInfo('print')"
                    data-cy="info-area-cut-list"
                    class="toggle-info-area-button bg-primary-50 rounded-l-[2rem] p-4 font-bold text-gray-600">
                {{ 'MAIN_LAYOUT.CUT_LIST' | translate }}
            </button>

        </div>


    </div>
    <div class="bg-white flex flex-col h-full transition-w duration-1000 ease-in-out pointer-events-auto overflow-x-hidden" #infoArea
         [ngClass]="showPrintInfo || showBillOfQuantitiesInfo ? 'w-3/4' : 'w-0'">

        <div id="infoArea" class="py-4 px-5 overflow-y-scroll flex-grow ml-4">


            @if (showBillOfQuantitiesInfo) {
                <app-quantity-listing class="animate-fade" [type]="'QUANTITY'"></app-quantity-listing>
            }

            @if (showPrintInfo) {
                <app-quantity-listing class="animate-fade" [type]="'CUTTING_PLAN'"></app-quantity-listing>
            }

        </div>

        <div class="h-28 bg-primary-500 flex flex-row w-full justify-evenly gap-6 align-middle p-4 md:text-nowrap">
            <button class="bg-white text-primary-500 w-fit h-fit py-4 uppercase font-semibold px-4 col-span-2 transition-colors hover:bg-primary-50 hover:text-secondary-500"
                    (click)="onRequestQuote()"
                    data-cy="info-area-request-quote">
                {{ 'BUTTONS.REQUEST_QUOTE' | translate }}
            </button>
            <button class="border-2 border-white text-white w-fit h-fit py-4 uppercase font-semibold px-4 col-span-2 transition-colors hover:border-secondary-500 hover:text-secondary-500 hover:bg-white"
                    (click)="print()"
                    data-cy="info-area-print">
                {{ 'BUTTONS.PRINT' | translate }} / {{ 'BUTTONS.DOWNLOAD' | translate }}
            </button>
        </div>
    </div>






</div>

@if(showPrintablePages) {
    <div #printableArea class="bg-white hidden " data-cy="info-area-print-window">
        <app-quantity-listing [type]="'QUANTITY'" [printable]="true" class="hidden print:block"></app-quantity-listing>
        <app-quantity-listing [type]="'CUTTING_PLAN'" class="hidden print:block" [printable]="true" [style.page-break-before]="'always'"></app-quantity-listing>
    </div>
}



